import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    columnVisibilityForTestrunCasesModal: {
    __check__ : true,
    key: true,
    title: true,
    comment: true,
    status: true,
    type: false,
    priority: false,
    labels: false,    
    generated_by_user: false,
    updated_by_user: false,
    created_at: false,
    updated_at: false,
    last_executed_date: false,
    last_executed_by: false,
    estimated_duration: false,
  },
};

const columnSliceForTestrunCases = createSlice({
  name: 'columnVisibilityForTestrunCases',
  initialState,
  reducers: {
    updateColumnVisibility(state, action) {
      const { columnName, visibility } = action.payload;
      state.columnVisibilityForTestrunCasesModal[columnName] = visibility;
    },
    setInitialColumnVisibility(state) {
      state.columnVisibilityForTestrunCasesModal = { ...initialState.columnVisibilityForTestrunCasesModal };
    },
  },
});

export const { 
    updateColumnVisibility, 
    setInitialColumnVisibility 
} = columnSliceForTestrunCases.actions;

export default columnSliceForTestrunCases.reducer;
